import Footer from "../../components/Footer";
import Header from "../../components/Header";
import AdvocacyLegalAdvisory from "../../components/Service/Subservice/advocacy";
 
import SubServiceBanner from "../../components/Service/Subservice/subservicebanner";

export default function AdvocacyLegalPage() {
    return (
        <>
            <Header/>
            <SubServiceBanner title={"Regulatory Advocacy & Legal Advisory"}/>
            <AdvocacyLegalAdvisory/>
            <Footer/>
        </>
    )
}